import types from './types';

const createCloseTips = () => (action) => (dispatch) => setTimeout(() => {
  dispatch({
    type: types.TIPS_CLOSE,
    payload: {},
  });
}, 2000);

export default {
  [types.TIPS_CHANGE]: [createCloseTips()],
};



// WEBPACK FOOTER //
// ./src/modules/tips/reactions.js